<template>
  <div>
    <transition appear name="loading-bar">
      <loading-bar v-show="pending"/>
    </transition>

    <b-card-header
        class="mb-0"
        header-bg-variant="transparent"
    >
      <b-form @submit.prevent="fetchData">
        <b-form-group :label="$t('Search')">
          <b-input-group>
            <b-form-input v-model="search"/>

            <b-input-group-append>
              <b-button :title="$t('Search')" type="submit">
                <fa icon="search"/>
              </b-button>

              <b-button
                  v-if="$gate.allow('create', 'element')"
                  :title="$t('Create new element')"
                  :to="{ name: 'projects.elements.create', params: {projectId: this.projectId } }"
                  variant="primary"
              >
                <fa icon="plus"/>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <show-deleted-items v-model="params.onlyTrashed"/>
      </b-form>
    </b-card-header>

    <b-card-body v-if="!pending && !items.length">
      <no-results-found class="mb-0"/>
    </b-card-body>

    <b-list-group flush>
      <b-list-group-item
          v-for="item in items"
          :key="item.id"
      >
        <project-elements-list-item
            :api-url="apiUrl"
            :value="item"
            @created="fetchData"
            @deleted="handleDelete"
            @input="handleUpdated"
        />
      </b-list-group-item>
    </b-list-group>

    <b-card-footer v-if="showPagination">
      <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="totalRows"
          align="center"
          class="mb-0"
      />
    </b-card-footer>

    <router-view @created="fetchData" @input="fetchData"/>
  </div>
</template>
<script>
import fetchPaginatedData from "@/mixins/fetchPaginatedData";
import ProjectElementsListItem from "@/components/project_elements/ListItem";
import crudListener from "@/mixins/crudListener";
import ShowDeletedItems from "@/components/ShowDeletedItems.vue";

export default {
  name: 'ProjectElements',
  components: {ShowDeletedItems, ProjectElementsListItem},
  mixins: [fetchPaginatedData, crudListener],
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      showCreateModal: false,
      items: [],
      newItem: {},
    };
  },
  computed: {
    apiUrl() {
      return '/api/projects/' + this.projectId + '/elements';
    },
  },
  methods: {
    handleDelete(item) {
      this.items.splice(this.items.indexOf(item), 1);
    },

    handleCreated(item) {
      this.items.push(item);
    },

    handleUpdated(item) {
      let index = this.items.findIndex(({id}) => id === item.id);
      this.items.splice(index, 1, item);
    },
  },
};
</script>
